import { LocalizationHelper } from '../../../../helpers/localization-helper'

import { BasicParameter } from '../../../common/parameters/extensions'
import { OpImportProgressStep } from '../../../../models/util/op-import-progress-step'

// #region Public Types
export const SERVICE_NAME: string = 'ImportErrorsSummaryService'
// #endregion

export class ImportErrorsSummaryService {

    public createErrorsSummaryParameters(currentProgressStep: OpImportProgressStep): BasicParameter[] {

        const parameters: BasicParameter[] = []
        
        const allCountParameter: BasicParameter = {
            caption: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.AllCount)
        }
        
        const successCountParameter: BasicParameter = {
            caption: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.SuccessCount)
        }

        const skippedCountParameter: BasicParameter = {
            caption: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.SkippedCount)
        }

        const warningCountParameter: BasicParameter = {
            caption: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.WarningCount)
        }

        const errorCountParameter: BasicParameter = {
            caption: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ErrorCount)
        }

        if (
            currentProgressStep != null &&
            currentProgressStep.proceedItemsCount != null &&
            currentProgressStep.proceedSuccessItemsCount != null &&
            currentProgressStep.proceedSkippedItemsCount != null &&
            currentProgressStep.proceedWarningItemsCount != null &&
            currentProgressStep.proceedErrorItemsCount != null
        ) {
            allCountParameter.value = currentProgressStep.proceedItemsCount
            successCountParameter.value = currentProgressStep.proceedSuccessItemsCount
            skippedCountParameter.value = currentProgressStep.proceedSkippedItemsCount
            warningCountParameter.value = currentProgressStep.proceedWarningItemsCount
            errorCountParameter.value = currentProgressStep.proceedErrorItemsCount
        }

        parameters.push(
            allCountParameter,
            successCountParameter,
            skippedCountParameter,
            warningCountParameter,
            errorCountParameter
        )

        return parameters
    }

}